import { render, staticRenderFns } from "./PackageContentOriginal.vue?vue&type=template&id=11d8ee33&scoped=true&"
import script from "./PackageContentOriginal.vue?vue&type=script&lang=ts&"
export * from "./PackageContentOriginal.vue?vue&type=script&lang=ts&"
import style0 from "./PackageContentOriginal.vue?vue&type=style&index=0&id=11d8ee33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d8ee33",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VImg,VRow})
